<ng-container *ngIf="!isLoading; else showSpinner">
  <ng-content></ng-content>
</ng-container>
<ng-template #showSpinner>
  <mat-spinner diameter="{{diameter}}"></mat-spinner>
</ng-template>
